// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5443) return "static/chunks/ad7f724d-365d834f95d30707.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","6350":"72a30a16","6925":"2c386607"}[chunkId] || chunkId) + "." + {"296":"9a85b5e70a39c188","4828":"397d7e7e5ddabbf3","6350":"e151e936289da131","6825":"df37b086b165b394","6925":"92cff45076fa0e17","7856":"3eeafc5151d77529","9260":"9c5362ceb8292372"}[chunkId] + ".js";
};